import { privateAxios } from 'services/api/privateAxios';
import { adminAPI } from 'services/api/apiUrl';

export const getCustomersList = ({
  page,
  pageSize,
  search = '',
  orderBy,
  orderDirection,
}) =>
  privateAxios({
    method: 'post',
    baseURL: adminAPI,
    url: '/customer/list',
    data: {
      page,
      pageSize,
      search,
      orderBy,
      orderDirection,
    },
  });
